/** The opt-ins a new account makes on the sign-up screens. */
export type SignupChoices = {
  newsletterConsent: boolean;
};

export const NO_SIGNUP_CHOICES: SignupChoices = {
  newsletterConsent: false,
};

/** Query entries for the Google redirect: present only when ticked. */
export function signupChoiceParams(choices: SignupChoices): [string, string][] {
  return choices.newsletterConsent ? [["newsletter_consent", "1"]] : [];
}

/** Body fields for the email registration request. */
export function signupChoiceFields(choices: SignupChoices) {
  return { newsletter_consent: choices.newsletterConsent };
}
